"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractMusicScale = void 0;
const __1 = require("..");
const notes_1 = require("../notes");
class AbstractMusicScale {
    constructor(tonic, mode, scale) {
        this.tonic = tonic;
        this.mode = mode;
        this.scaleType = scale;
        this.normalizedMode = this.getNormalizedMode();
        this.name = this.getName();
        this.modeAlias = this.getModeAlias();
    }
    getNormalizedMode() {
        return this.mode;
    }
    /** @inheritdoc */
    get formattedName() {
        return (0, __1.formatAccidentals)(this.name);
    }
    /** @inheritdoc */
    get signature() {
        return this._signature || (this._signature = this.getSignature());
    }
    /** @inheritdoc */
    get notes() {
        return this._notes || (this._notes = this.getNotesInScale());
    }
    /** @inheritdoc */
    get chords() {
        return this._chords || (this._chords = this.getChordsInScale());
    }
    /** Gets the accidental used by this key */
    get accidental() {
        return this.tonic.accidental;
    }
    getNoteInScale(note) {
        if (typeof note === "string") {
            note = (0, notes_1.getNote)(note);
        }
        if (note.alias && note.accidental !== this.tonic.accidental && note.alias.accidental === this.accidental) {
            note = note.alias;
        }
        return note;
    }
    /** @inheritdoc */
    getChordInScale(chord) {
        const note = this.getNoteInScale(chord.root);
        if (chord.accidental !== note.accidental) {
            return chord.aliasChord;
        }
        return chord;
    }
    /** @override */
    toString() {
        return this.name;
    }
    /** @inheritdoc */
    equals(scale) {
        return this.name === scale.name;
    }
    /** @inheritdoc */
    isSameAs(scale) {
        return this.tonic.number === scale.tonic.number
            && (this.mode === scale.mode || this.modeAlias === scale.mode);
    }
    /**
     * Gets all of the notes in a scale with the specified root
     * @param scale The scale to get notes for
     */
    getNotesInScale() {
        const intervals = this.getIntervals();
        if (!intervals) {
            throw new Error("Invalid scale: " + this.name);
        }
        const tonicNote = this.tonic;
        const notes = intervals.map(i => {
            // Compute the next note from the tonic and interval
            const note = tonicNote.transpose(i);
            // What should we call it in this scale?
            return this.getNoteInScale(note);
        });
        return notes;
    }
}
exports.AbstractMusicScale = AbstractMusicScale;
//# sourceMappingURL=music-scale.js.map